import React, {useEffect, useState} from 'react';
import Ingredient from "../../model/menudesign/Ingredient";
import '../../styles/Commons.css';
import {Button, Card, Table, Tag} from "antd";
import type {ColumnsType, TableProps} from 'antd/es/table';
import {GetHistorialByPantalla} from "../../dao/GetHistorialByPantalla";
import {Historial} from "../../model/Historial";
import Colors from "../../styles/Colors";
import {BiRefresh} from "react-icons/bi";

interface historialPantalla {
    pantalla: string,
    pagina: string
}

const Historials: React.FC<historialPantalla> = ({pantalla, pagina}) => {

    //TODO: Eliminar
    const initialIngredients: Ingredient[] = [new Ingredient()];
    const [historial, setHistorial] = useState<Historial[]>([]);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        checkHistorial();
    }, []);


    async function checkHistorial() {
        handleLoadingChange(true)
        console.log("PAG: " + pagina);
        const historials = await GetHistorialByPantalla(pantalla, pagina);
        await setHistorial(historials);
        await handleLoadingChange(false);
    }

    function checkDates(a: string, b: string) {
        const dateA = new Date(a);
        const dateB = new Date(b);

        return dateB.getTime() - dateA.getTime();
    }

    const columns: ColumnsType<Historial> = [
        {
            key: 'missatge', title: 'Missatge', dataIndex: 'missatge', width: 30,
        },
        {
            key: 'tipus', title: 'Tipus', dataIndex: 'tipus', width: 20,
            render: (tipus: number) => (
                <Tag color={tipus == -1 ? "magenta" : (tipus == 0 ? "cyan" : "lime")}>
                    {tipus == -1 ? "eliminat" : (tipus == 0 ? "modificat" : "afegit")}
                </Tag>
            ),
        },
        {
            key: 'moment', title: 'Moment', dataIndex: 'moment', width: 30,
            sorter: (a, b) => checkDates(a.moment, b.moment),
            sortOrder: "ascend",
            render: (moment: string) => (
                <p>{moment.substring(0, moment.lastIndexOf(":") + 3)}</p>
            ),
        },
        {
            key: 'usuari', title: 'Usuari', dataIndex: 'usuari', width: 20,
        },
    ];

    const tableProps: TableProps<Historial> = {
        loading
    };

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function toggleTable() {
        setVisible(!visible);
        if (!visible) checkHistorial();
    }

    return (
        <Card bordered={true} className={"elemento"}>
            <div className={"actionButtons"}>
                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                    checkHistorial()}><BiRefresh/></Button>
            </div>
            <h4 className={"subtitol"} onClick={toggleTable}>Historial</h4>
            {visible && (
                <Table
                    {...tableProps}
                    columns={columns}
                    dataSource={historial}
                />
            )}
        </Card>
    );
};

export default Historials;
